import React from 'react'
import { PMPBodySectionItems } from './styledComponent'
import { PRESCRIPTION_COLORS_MAP } from '../../../inputComponents/common/color-utils'
import {
  getCasedHeadingTextBasedOnStyleOverrides,
  getValidDiagnosisArrayForPrescription,
  prepareDiagnosisSuffix,
} from './util'
import { applyNameCase, getSectionListFormatConfig } from './sectionListFormat'

export default function PrintableDiagnosis({
  diagnosisRef,
  debug,
  selectedDiagnosis,
  debugHighlightStates,
  styleOverrides,
  listItemSeparator,
}) {
  const diagnosisToShow = getValidDiagnosisArrayForPrescription(selectedDiagnosis)
  const cfg = getSectionListFormatConfig(styleOverrides, listItemSeparator)
  // Diagnosis name (key) vs the duration/date suffix (value), styled independently.
  const nameStyle = { fontWeight: cfg.bold ? 700 : 'inherit', color: cfg.keyColor || 'inherit' }
  const valueStyle = { color: cfg.valueColor || 'inherit' }
  const renderDiagnosisItem = (item) => (
    <>
      <span style={nameStyle}>{applyNameCase(item?.label, cfg.capitalize)}</span>
      <span style={valueStyle}>{prepareDiagnosisSuffix(item)}</span>
    </>
  )

  return (
    <PMPBodySectionItems
      ref={diagnosisRef}
      debug={debug}
      debugColor={PRESCRIPTION_COLORS_MAP.diagnosis?.color}
      debugHighlight={debugHighlightStates?.diagnosis}
      borderLeft={styleOverrides?.borderLeft}
      paddingLeft={styleOverrides?.paddingLeft}
    >
      <span
        style={{
          fontSize: styleOverrides?.headingFontSize
            ? `${styleOverrides?.headingFontSize}px`
            : 'inherit',
          color: styleOverrides?.headingColor || styleOverrides?.color || 'inherit',
          fontWeight: 600,
        }}
      >
        <strong>
          {getCasedHeadingTextBasedOnStyleOverrides({
            headingText: 'Diagnosis',
            styleOverrides,
          })}
        </strong>
      </span>
      <div
        style={{
          fontSize: styleOverrides?.fontSizePixels
            ? `${styleOverrides?.fontSizePixels}px`
            : 'inherit',
          color: styleOverrides?.color || 'inherit',
          wordWrap: 'break-word',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          maxWidth: '100%',
        }}
        className={cfg.isBullet ? '' : 'd-flex align-items-center gap-1 flex-wrap'}
      >
        {cfg.isBullet ? (
          <ul style={{ margin: 0, paddingLeft: '20px' }}>
            {diagnosisToShow.map((diagnosisItem, idx) => (
              <li key={idx}>{renderDiagnosisItem(diagnosisItem)}</li>
            ))}
          </ul>
        ) : (
          diagnosisToShow.map((diagnosisItem, idx) => (
            <div style={{ paddingRight: '6px' }} key={idx}>
              {renderDiagnosisItem(diagnosisItem)}
              {diagnosisToShow?.length - 1 !== idx && cfg.separator}
            </div>
          ))
        )}
      </div>
    </PMPBodySectionItems>
  )
}
